<template>
  <el-container class="chat-page">
    <el-aside width="320px" class="chat-list-box">
      <div class="chat-list-header">
        <el-input class="search-text" size="small" placeholder="" v-model="searchText">
          <i class="el-icon-search el-input__icon" slot="prefix"> </i>
        </el-input>
      </div>
      <div class="chat-list-loading" v-if="loading" v-loading="true" element-loading-text="メッセージを受信中..."
        element-loading-spinner="el-icon-loading" element-loading-background="#F9F9F9" element-loading-size="24">
      </div>
      <el-scrollbar class="chat-list-items" v-else>
        <!-- <el-collapse v-model="activeNames" style="padding: 0 2.5%;background-color: #fff;">
          <el-collapse-item :title="group" :name="index" v-for="(group, index) in chatStore.chatGroups" :key="group">
            <div v-for="(chat, idx) in chatsByGroup(group)" :key="chat.targetId">
              <chat-item v-show="!chat.delete && chat.showName.includes(searchText)" :chat="chat" :index="idx"
                @click.native="onActiveItem(idx)" @delete="onDelItem(idx)" @top="onTop(idx)" @disturb="onDisturb"
                @cancel_disturb="handleCancelDisturb" :active="chat === chatStore.activeChat"></chat-item>
            </div>
          </el-collapse-item>
        </el-collapse> -->

        <!-- 更新后 -->
        <chat-item v-if="systemChat" :chat="systemChat" :index="0"
          @click.native="onActiveItem(chatStore.chats.indexOf(systemChat))"
          @delete="onDelItem(chatStore.chats.indexOf(systemChat))" @top="onTop(chatStore.chats.indexOf(systemChat))"
          @disturb="onDisturb" @cancel_disturb="handleCancelDisturb" :active="systemChat === chatStore.activeChat">
        </chat-item>

        <!-- 原来的 -->
        <!-- <div v-for="(chat, index) in chatStore.chats" :key="index">
          <chat-item v-show="!chat.delete && chat.showName.includes(searchText)" :chat="chat" :index="index"
            @click.native="onActiveItem(index)" @delete="onDelItem(index)" @top="onTop(index)" @disturb="onDisturb"
            @cancel_disturb="handleCancelDisturb" :active="chat === chatStore.activeChat"></chat-item>
        </div> -->

        <!-- 更新后 -->
        <div v-for="(chat) in normalChats" :key="(chat.id || chat.targetId) + '_' + chat.type">
          <chat-item :chat="chat" :index="chatStore.chats.indexOf(chat)"
            @click.native="onActiveItem(chatStore.chats.indexOf(chat))"
            @delete="onDelItem(chatStore.chats.indexOf(chat))" @top="onTop(chatStore.chats.indexOf(chat))"
            @disturb="onDisturb" @cancel_disturb="handleCancelDisturb" :active="chat === chatStore.activeChat">
          </chat-item>
        </div>
      </el-scrollbar>
    </el-aside>
    <el-container class="chat-box">
      <!-- <keep-alive> -->
      <chat-box v-if="activeChat && activeChat.type && activeChat.type != 'SYSTEM'" :chat="activeChat"
        :key="activeChat ? activeChat.targetId + '_' + activeChat.type : 'default'"></chat-box>
      <chat-system-box v-if="activeChat && activeChat.type && activeChat.type == 'SYSTEM'" :chat="activeChat"
        :key="activeChat ? activeChat.targetId + '_' + activeChat.type : 'system'"></chat-system-box>
      <!-- </keep-alive> -->
    </el-container>
  </el-container>
</template>

<script>
import ChatItem from "../components/chat/ChatItem.vue";
import ChatBox from "../components/chat/ChatBox.vue";
import ChatSystemBox from "../components/chat/ChatSystemBox.vue";
export default {
  name: "chat",
  components: {
    ChatItem,
    ChatBox,
    ChatSystemBox
  },
  data() {
    return {
      searchText: "",
      messageContent: "",
      group: {},
      groupMembers: [],
      activeNames: [0, 1, 2, 3, 4]
    }
  },
  methods: {
    chatsByGroup(group) {
      return this.chatStore.chats.filter(chat => chat.group === group && !chat.delete);
    },
    onActiveItem(index) {
      this.$store.commit("activeChat", index);
    },
    onDelItem(index) {
      this.$store.commit("removeChat", index);
    },
    onTop(chatIdx) {
      // console.log("onTop", chatIdx);
      this.$store.commit("moveTop", chatIdx);
    },
    // 消息免打扰
    onDisturb(chat) {
      try {
        this.$http({
          url: 'shutlist/add?userId=' + chat.targetId,
          method: 'post',
        }).then(response => {
          // 更新本地状态
          this.$store.commit('setShutFlag', {
            chatInfo: {
              type: chat.type,
              targetId: chat.targetId
            },
            shutFlag: !chat.shutFlag // 切换状态
          });

          // 强制刷新列表（可选）
          this.$forceUpdate();
        })

      } catch (error) {
        console.error('ノードライブ設定に失敗しました', error);
      }
    },
    //  取消免打扰
    handleCancelDisturb(chat) {
      // console.log(this.chatStore.chats, 'chat')
      this.$http({
        url: 'shutlist/remove?userId=' + chat.targetId,
        method: 'delete',
      }).then(response => {
        // 更新本地状态
        this.$store.commit('setShutFlag', {
          chatInfo: {
            type: chat.type,
            targetId: chat.targetId
          },
          shutFlag: !chat.shutFlag // 切换状态
        });

        // 强制刷新列表（可选）
        this.$forceUpdate();
      })
    },
    // 查询是否免打扰
    checkShutFlag() {
      this.$http({
        url: 'shutlist/list',
        method: 'get',
      }).then(response => {
        // 判断是否有数据
        if (response.length > 0) {
          // 遍历chatStore.chats和response.data，更新匹配的chat的shutFlag
          if (this.chatStore.chats.length > 0) {
            this.chatStore.chats.map(chat => {
              response.map(item => {
                if (chat.targetId == item) {
                  chat.shutFlag = true;
                }
              })
            });
          }
          // console.log(this.chatStore.chats, 'this.chatStore.chats')

        }
      })
    }
  },
  computed: {
    chatStore() {
      // console.log(this.$store.state.chatStore, 'this.$store.state.chatStore')
      return this.$store.state.chatStore;
    },
    activeChat() {
      return this.chatStore.activeChat;
    },
    loading() {
      return this.chatStore.loadingGroupMsg || this.chatStore.loadingPrivateMsg
    },
    systemChat() {
      // 只取第一个 type 为 SYSTEM 的会话
      return this.chatStore.chats.find(chat => chat.type === 'SYSTEM' && !chat.delete && chat.showName.includes(this.searchText));
    },
    normalChats() {
      // 过滤掉 SYSTEM 类型的会话
      return this.chatStore.chats.filter(chat => chat.type !== 'SYSTEM' && !chat.delete && chat.showName.includes(this.searchText));
    },
  },
  mounted() {
    setTimeout(() => {
      this.checkShutFlag();
    }, 2000);
  }
}
</script>

<style lang="scss">
.chat-page {
  .chat-list-box {
    display: flex;
    flex-direction: column;
    background: var(--im-background);

    .chat-list-header {
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0 8px;
    }

    .chat-list-loading {
      height: 50px;
      background-color: #eee;

      .el-icon-loading {
        font-size: 24px;
        color: var(--im-text-color-light);
      }

      .el-loading-text {
        color: var(--im-text-color-light);
      }

      .chat-loading-box {
        height: 100%;
      }
    }

    .chat-list-items {
      flex: 1;
    }
  }
}
</style>
